export enum UserRole {
  CBM_LOCATION_ADMIN = 'CBM_LOCATION_ADMIN',
  CBM_MAP_ADMIN = 'CBM_MAP_ADMIN',
  CBM_APPLICATION_ADMIN = 'CBM_APPLICATION_ADMIN'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/userrole.ts